import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3155ff8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mt-8 mb-4 justify-items-stretch flex flex-col text-lg" }
const _hoisted_10 = ["name", "value", "onChange"]
const _hoisted_11 = {
  key: 0,
  class: "sm:col-span-4 h-full min-h-50vh flex flex-col items-center justify-center"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_15 = ["href", "innerHTML"]
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 0,
                  class: _normalizeClass(["text-3xl font-medium", {'text-project': !_ctx.config.themeDark}]),
                  innerHTML: _ctx.$t(_ctx.config.title, {name: _ctx.state.nickname.value})
                }, null, 10, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass(["mt-4", _ctx.config.classes?.questionClass]),
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 10, _hoisted_6),
            (_ctx.config.image1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.config.image1,
                    class: "h-20",
                    alt: "Logo"
                  }, null, 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: key,
                  class: _normalizeClass(["flex flex-row items-center mb-4", _ctx.config.classes?.optionClass])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: _ctx.config.answerKey,
                    value: key,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.answers.value[_ctx.config.answerKey]) = $event)),
                    onChange: ($event: any) => (_ctx.answer(key, {[key]: _ctx.$t(option)})),
                    class: "inline mr-4 large-radio-circle"
                  }, null, 40, _hoisted_10), [
                    [_vModelRadio, _ctx.state.answers.value[_ctx.config.answerKey]]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(option)), 1)
                ], 2))
              }), 128))
            ]),
            (_ctx.selected)
              ? (_openBlock(), _createBlock(_component_BackNextButtons, {
                  key: 3,
                  "go-to": _ctx.goTo,
                  "next-screen": _ctx.config.screenNext,
                  "button-class": "action-button action-button-project2 mt-8"
                }, null, 8, ["go-to", "next-screen"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.config.bgImage)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "bg-project w-full p-16 aspect-square flex flex-col items-center justify-center",
                      style: _normalizeStyle(_ctx.config.bgStyles)
                    }, [
                      _createElementVNode("p", {
                        class: "text-white font-normal",
                        innerHTML: _ctx.$t(_ctx.config.textPart4)
                      }, null, 8, _hoisted_12),
                      _createElementVNode("img", {
                        src: _ctx.config.bgImage,
                        class: "w-full",
                        alt: "Logo"
                      }, null, 8, _hoisted_13)
                    ], 4))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_15))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_16))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}